"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExportExportableFieldClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("../authenticated.client");
class DataExportExportableFieldClient extends authenticated_client_1.AuthenticatedClient {
    GetExportableFields(accountId, projectId, scope) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/accounts/${accountId}/exportable-fields?projectId=${projectId}&scope=${scope}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.DataExportExportableFieldClient = DataExportExportableFieldClient;
//# sourceMappingURL=data-export-exportable-field.client.js.map